import { useCallback, useRef, useState, type FormEvent } from 'preact/compat';

import { AppSettings } from '@/constants/app-settings';

type Props = {
  organizationId: string;
};

export function RegisterForm({ organizationId }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const emailInputRef = useRef<HTMLInputElement>(null);

  const onRegister = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      setIsLoading(true);

      const response = await fetch(
        `${AppSettings.apiUrl}/chats/auth/register`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: emailInputRef.current?.value,
            organizationId,
          }),
        },
      );

      if (!response.ok) {
        // TODO: Handle error and show error message to user
        console.error('Failed to register');
        setIsLoading(false);

        return;
      }

      setIsLoading(false);
      setIsDone(true);
    },
    [organizationId],
  );

  return (
    <div className='flex w-full justify-center'>
      {!isDone && (
        <form className='w-full' onSubmit={onRegister}>
          <div className='flex gap-2'>
            <div className='relative flex-1 rounded-2xl border border-[#e4e4e7] bg-white transition-all focus-within:border-[#9c70ff] focus-within:ring-2 focus-within:ring-[#9c70ff]/20'>
              <input
                ref={emailInputRef}
                data-cta='web-input-register-form-email-input'
                className='w-full rounded-2xl px-4 py-2.5 text-sm text-[#1a1a1a] outline-none placeholder:text-[#71717a]/50'
                type='email'
                name='email'
                placeholder='Váš email'
                required
                disabled={isLoading}
              />
            </div>
            <button
              data-cta='web-input-register-form-submit-button'
              type='submit'
              className='inline-flex shrink-0 items-center justify-center gap-2 rounded-2xl bg-[#9c70ff] px-4 py-2.5 text-sm font-medium text-white transition-all hover:bg-[#8a58ff] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9c70ff]/50 disabled:pointer-events-none disabled:opacity-50'
              disabled={isLoading}
            >
              Ověřit e-mail
            </button>
          </div>
        </form>
      )}
      {isDone && (
        <div className='flex items-center gap-2 rounded-2xl border border-[#9c70ff]/30 bg-[#9c70ff]/10 px-4 py-2.5'>
          <span className='text-sm font-medium text-[#7c3aed]'>
            Koukněte do emailu a potvrďte registraci
          </span>
        </div>
      )}
    </div>
  );
}
